import {
    $authHost,
    $host,
    refreshAccessToken
} from './index';
import jwt_decode from "jwt-decode";

export const registration = async (email, nickname, password) => {
    try {
        const response = await $host.post('api/user/registration', {email, nickname, password})
        if (response.data.accessToken) {
            localStorage.setItem('token', response.data.accessToken)
            return jwt_decode(response.data.accessToken)
        }

        // Если регистрации по коду → возвращаем сообщение и данные юзера
        return {
            message: response.data.message,
            user: response.data.user
        }

    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при регистрации.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}
export const login = async (email, password) => {
    try  {
        const response = await $host.post('api/user/login', {email, password})

        if (response.data.accessToken) {
            localStorage.setItem('token', response.data.accessToken)
            return jwt_decode(response.data.accessToken)
        }

        return {
            message: response.data.message,
            user: response.data.user
        }
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при входе.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}

export const loginByCode = async (email, code) => {
    try {
        // Отправляем email и код на роут для завершения входа
        const response = await $host.post('api/user/login/code', { email, code });

        // Если вход успешен, бэкенд возвращает токены
        if (response.data.accessToken) {
            // Сохраняем access токен
            localStorage.setItem('token', response.data.accessToken);
            // Возвращаем данные пользователя из токена
            return jwt_decode(response.data.accessToken);
        }

        // Этот блок на всякий случай, если бэкенд не вернул токены
        return response.data;

    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при входе по коду.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}

export const logout = async () => {
    try {
        await $host.post('api/user/logout');
    } finally {
        localStorage.removeItem('token');
    }
};

export const sendLoginCode = async (email) => {
    try{
        const {data} = await $host.post('api/user/login/code/send', { email })
        return data
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при получении пользователя.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}


export const refresh = async () => {
    return refreshAccessToken();
};

export const checkAuth = async () => {
    const { data } = await $authHost.get("api/user/auth");
    return data.user;
};

export const fetchOneUser = async (id) => {
    try{
        const {data} = await $host.get('api/user/' + id)
        return data
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при получении пользователя.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}

export const updateNickname = async (newNickname) => {
    try {
        const { data } = await $authHost.put('api/user/nickname', { nickname: newNickname });
        return data; // вернёт { message, user }
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Ошибка при обновлении никнейма.';
        throw new Error(errorMessage);
    }
};

export const updateProfilePhoto = async (formData) => {
    try {
        const { data } = await $authHost.put('api/user/photo', formData, {
        });

        return data;
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Ошибка при обновлении фото профиля.';
        throw new Error(errorMessage);
    }
};

export const createBrowserHandoff =
    async () => {
        try {
            const {
                data
            } =
                await $authHost.post(
                    'api/user/browser-handoff'
                );

            return data;

        } catch (e) {
            const errorMessage =
                e.response?.data?.message ||
                'Не удалось подготовить переход в другой браузер.';

            throw new Error(
                errorMessage
            );
        }
    };


export const redeemBrowserHandoff =
    async code => {
        try {
            const {
                data
            } =
                await $host.post(
                    'api/user/browser-handoff/redeem',
                    {
                        code
                    }
                );


            if (
                !data?.accessToken
            ) {
                throw new Error(
                    'Сервер не вернул accessToken'
                );
            }


            localStorage.setItem(
                'token',
                data.accessToken
            );


            return data;

        } catch (e) {
            const errorMessage =
                e.response?.data?.message ||
                e.message ||
                'Не удалось перенести авторизацию.';

            throw new Error(
                errorMessage
            );
        }
    };




// Passwordless SMS Aero sign-in. Endpoints remain disabled until SMS_AUTH_ENABLED=true on API.
const phoneApiError = (e, fallback) => {
    const error = new Error(e.response?.data?.message || fallback);
    const code = e.response?.data?.errors?.find?.(item => typeof item?.code === 'string')?.code;
    if (code) error.code = code;
    return error;
};

export const sendPhoneLoginCode = async ({ name, phone, consent }) => {
    try {
        const { data } = await $host.post('api/user/phone/login/start', { name, phone, consent });
        return data;
    } catch (e) { throw phoneApiError(e, 'Не удалось отправить SMS'); }
};

export const confirmPhoneLoginCode = async ({ phone, challengeId, code }) => {
    try {
        const { data } = await $host.post('api/user/phone/login/confirm', { phone, challengeId, code });
        if (!data.accessToken) throw new Error('Сервер не вернул токен входа');
        localStorage.setItem('token', data.accessToken);
        return jwt_decode(data.accessToken);
    } catch (e) { throw phoneApiError(e, e.message || 'Не удалось подтвердить номер'); }
};

export const getMyVerifiedPhone = async () => {
    const { data } = await $authHost.get('api/user/phone/status');
    return data;
};

export const sendPhoneLinkCode = async phone => {
    try {
        const { data } = await $authHost.post('api/user/phone/link/start', { phone });
        return data;
    } catch (e) { throw phoneApiError(e, 'Не удалось отправить SMS'); }
};

export const confirmPhoneLinkCode = async ({ phone, challengeId, code }) => {
    try {
        const { data } = await $authHost.post('api/user/phone/link/confirm', { phone, challengeId, code });
        return data;
    } catch (e) { throw phoneApiError(e, 'Не удалось привязать телефон'); }
};
